__turbopack_context__.v({
  "fill": "Picture-module__RfCP4a__fill",
  "full-width": "Picture-module__RfCP4a__full-width",
  "image": "Picture-module__RfCP4a__image",
});
